import type { Pagina } from '@/shared/api/cliente';

export type Situacion = 'PENDIENTES' | 'EXTINGUIDOS' | 'TODOS';

export type FormaDeExtincion =
  'PAGO_SIRE' | 'PAGO_API_GIRS' | 'PAGO_ANTERIOR' | 'COBRO' | 'PRESCRIPCION' | 'BAJA';

export const FORMAS: readonly { valor: FormaDeExtincion; etiqueta: string }[] = [
  { valor: 'PAGO_SIRE', etiqueta: 'Pagado en el SIRE' },
  { valor: 'PAGO_API_GIRS', etiqueta: 'Pagado en la API GIRS' },
  { valor: 'PAGO_ANTERIOR', etiqueta: 'Pagado en el sistema anterior' },
  { valor: 'COBRO', etiqueta: 'Cobrado en caja' },
  { valor: 'PRESCRIPCION', etiqueta: 'Prescrito' },
  { valor: 'BAJA', etiqueta: 'Dado de baja' },
];

export interface Extincion {
  forma: FormaDeExtincion;
  etiqueta: string;
  fecha: string;
  capital: number;

  interes: number;
  referencia?: string;
  documento?: string;

  observacion?: string;
  registradoPor?: string;
  facturaId?: number;
}

export interface PagoAnteriorRegistrado {
  titulos: number;
  capital: number;
  numeroDeFactura: string;
  fecha: string;
  identificacion?: string;
  nombre?: string;
}

export interface Titulo {
  id: number;
  codigo?: string;
  identificacion?: string;
  nombre?: string;
  parroquia?: string;
  desde?: string;
  hasta?: string;
  meses?: number;
  capital: number;
  saldo: number;
  anexos?: string;
  extincion?: Extincion;
}

export interface ListadoDeTitulos extends Pagina<Titulo> {
  totales: { titulos: number; capital: number; saldo: number };
}

export interface ResumenDeTitulos {
  pendientes: number;
  personas: number;
  saldo: number;
  extinguidos: {
    forma: FormaDeExtincion;
    etiqueta: string;
    titulos: number;
    capital: number;
    interes: number;
  }[];
}

export type MotivoDeBaja = 'DUPLICADO' | 'ERROR_DE_EMISION' | 'INCOBRABLE' | 'OTRO';

export const MOTIVOS_DE_BAJA: readonly { valor: MotivoDeBaja; etiqueta: string }[] = [
  { valor: 'DUPLICADO', etiqueta: 'Título duplicado' },
  { valor: 'ERROR_DE_EMISION', etiqueta: 'Error de emisión' },
  { valor: 'INCOBRABLE', etiqueta: 'Incobrable' },
  { valor: 'OTRO', etiqueta: 'Otro' },
];

export interface Resolucion {
  id: number;
  tipo: 'PRESCRIPCION' | 'BAJA';
  motivo?: MotivoDeBaja;
  motivoNombre?: string;
  numero: string;
  fecha: string;
  tramite?: string;
  observacion?: string;
  identificacion?: string;
  nombre: string;
  titulos: number;
  capital: number;
  archivoNombre?: string;
  /** Sin el PDF de la resolución: las migradas del SIRE, que solo guardaba el número. */
  pdfPendiente: boolean;
  registradoPor: string;
  registradoEn: string;
  vigente: boolean;
  revertidaEn?: string;
  revertidaPor?: string;
  motivoReversion?: string;
}
